__turbopack_context__.v({
  "label": "promptVersionSelect-module-scss-module__1C6ouW__label",
  "select": "promptVersionSelect-module-scss-module__1C6ouW__select",
});
